import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';

import App from './app';
import { FirebaseProvider } from './lib/firebase-context';
import { ToastProvider } from './lib/toast-context';
import { UserContextProvider } from './lib/users-context';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
  components: {
    MuiTooltip: {
      defaultProps: {
        enterDelay: 0,
        enterNextDelay: 0,
        enterTouchDelay: 0,
      },
      styleOverrides: {
        tooltip: { fontSize: '0.875rem' },
      },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ThemeProvider theme={darkTheme}>
    <CssBaseline>
      <ToastProvider>
        <UserContextProvider>
          <FirebaseProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </FirebaseProvider>
        </UserContextProvider>
      </ToastProvider>
    </CssBaseline>
  </ThemeProvider>
);
